export enum VisualizationType {
  FORECAST = "FORECAST",
  PROBABILISTIC = "PROBABILISTIC",
  SENSOR = "SENSOR",
}
